export default "__VITE_ASSET__Gfovz8Kv__"